import { getNativeCurrencyCode, getLocale } from '@helpers/env'
import trackError from '@helpers/trackError'

type CurrencyConverterProps = {
  price: string | number | bigint
  currency?: string
  decimals?: boolean
}

type CurrencyOptions = {
  style: string
  currency: string
  currencyDisplay: string
  minimumSignificantDigits?: number
  maximumSignificantDigits?: number
}

function currencyConverter({
  price,
  currency = getNativeCurrencyCode(),
  decimals = true
}: CurrencyConverterProps): string {
  try {
    let priceFormatted = formatPriceForLocale(price, currency, decimals)
    priceFormatted = removeTrailingZeros(priceFormatted)
    priceFormatted = disambiguateCurrency(priceFormatted, currency)
    return priceFormatted
  } catch (e) {
    const error = e as Error
    trackError(new Error(error.message))
    return String(price)
  }
}

function formatPriceForLocale(
  price: string | number | bigint,
  currency: string,
  decimals: boolean
): string {
  let props: CurrencyOptions = {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol'
  }

  if (!decimals) {
    props = {
      ...props,
      minimumSignificantDigits: 1,
      maximumSignificantDigits: 3
    }
  }

  return new Intl.NumberFormat(getLocale(), props).format(Number(price))
}

function removeTrailingZeros(price: string): string {
  return price.replace(/\.0+$/, '')
}

function disambiguateCurrency(price: string, currency: string): string {
  const ambiguousCurrencySymbols = ['$']

  if (ambiguousCurrencySymbols.some(s => price.includes(s))) return `${price} ${currency}`
  return price
}

export default currencyConverter
